import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadSymbolListEpic } from './_epic/loadSymbolList.epic';
import { loadDetailsEpic } from './_epic/loadDetails.epic';

export const exposureEpic = safeCombineEpics(
  loadSymbolListEpic,
  loadDetailsEpic,
);
